import { getCurrentUserId } from 'auth/userIdentity';
import type { Lease } from 'store/storageunits/types';

export const isLeasedByAnotherUser = (
  exclusiveLease: Lease | undefined,
): boolean => {
  const sub = getCurrentUserId();
  return !!exclusiveLease && exclusiveLease.userId !== sub;
};

export const isLeasedByCurrentUser = (
  exclusiveLease: Lease | undefined,
): boolean => {
  const sub = getCurrentUserId();
  return !!exclusiveLease && exclusiveLease.userId === sub;
};
